<template>
    <div>
        <strong class="mb-1">
            <template v-if="address.label">{{ address.label }}<br></template>
            <template v-if="address.first_name">{{ address.first_name }} {{
                address.last_name }}
            </template>
            <small class="d-block" v-if="address.organization">
                {{ address.organization }}
            </small>
        </strong>
        <address class="small mt-3 mb-0">
            <template v-if="address.street">{{ address.street }}<br></template>
            <template v-if="address.postal_code || address.city">{{
                address.postal_code }} {{ address.city }}<br></template>
            <template v-if="address.country_code">{{ address.country_code }}</template>
        </address>
    </div>
</template>
<script>
    export default {
        name: 'AddressInfo',
        props: {
            address: {
                type: Object,
                required: true
            }
        }
    }
</script>
